export default "__VITE_ASSET__8qCu74MT__"